<template>
    <div class="mt4-status">
<!--      enableReadOnly为null 就是账号过期了,测试环境账号过期了,可以重新开账户-->
        <span class="theme-green" v-if="accountInfo.enableReadOnly == 0">
             {{$t('User.startUsing')}}
        </span>
        <span
                class="disable-status"
                v-if="accountInfo.enableReadOnly == 1"
                :class="{'theme-font': redColor}"
        >
            {{disabledText}}
            <el-tooltip placement="top">
              <div
                      class="content-box"
                      slot="content"
                      :style="disabledStyle"
              >
                <!-- $t('readOnlyTips')-->
                  <p>{{readOnlyTips}}</p>
              </div>
              <i class="el-icon-info icon-el iconcolor" :class="{'theme-font': redColor}"></i>
            </el-tooltip>
        </span>
    </div>
</template>

<script>
  export default {
    name: 'mt4Status',
    props: {
      accountInfo: {
        type: Object,
        default(){
          return {
            businessType: '',
            tier: '',
          }
        }
      },
    },
    computed: {
      disabledText(){
        return this.$t('Read_only');
      },
      disabledStyle(){
        if(this.accountInfo.businessType !== 6 && this.accountInfo.businessType !== 5){
          return {
            width: '300px'
          }
        }else {
          return {};
        }
      },
      isMamSub(){
        return this.accountInfo.businessType == 2 && this.accountInfo.tier == 2;
      },
      redColor(){
        if(this.isMamSub){
          return false;
        }
        if((this.accountInfo.accType == 'ECN' && this.accountInfo.balance < this.accountInfo.least) || (this.accountInfo.accType == 'PRO' && this.accountInfo.balance < this.accountInfo.least)){
          return true;
        }else {
          if(this.accountInfo.businessType == 5 || this.accountInfo.businessType == 6 ){
            return false;
          }else {
            return true;
          }
        }
      },
      readOnlyTips(){

        if(this.isMamSub){
          //mam投资账户永远显示这个
          return this.$t('mamSubReadyOnlyTips');
        }
        if(this.accountInfo.businessType == 5 || this.accountInfo.businessType == 6){
          return this.$t('Account_has_expired');
        }else {
          if(this.accountInfo.accType == 'ECN' && this.accountInfo.balance < this.accountInfo.least){
            return this.$t('ecnReadyOnlyTips', { money:  this.accountInfo.least });
          }else if(this.accountInfo.accType == 'PRO' && this.accountInfo.balance < this.accountInfo.least){
            return this.$t('proReadyOnlyTips',{ money:  this.accountInfo.least });
          }else {
            return this.$t('readOnlyTips');
          }
        }
      }
    },
  };
</script>

<style lang="scss" scoped>
.mt4-status {
  .iconfont {
    font-size: 12px;
  }
  .disable-status{
    line-height: normal;
  }
}
</style>
